<template>
  <c-modal
    v-model="model"
    cancel-label="Never mind"
    centered
    size="md"
    title="Change Server Name"
    :tag="false"
    @hide="hide"
    label=""
    confirm-label="Change Server Name"
    :progressing="progressing"
    @submit="submit"
  >
    <template #activator>
      <b-btn variant="warning" class="font-weight-bold" block @click="showModal">
        Change Server Name
        <span v-if="$showApprove([3, 4, 5, 11, 12])">
          *
        </span>
      </b-btn>
      <approve-permission
        :orderId="orderId"
        :tab-no="order.TabNo"
        action-type="ChangeServerName"
        @acceptPermission="openWithAcceptPermission"
        v-model="approveModal"
      />
    </template>
    <template>
      <b-form-group class="mb-0" v-if="servers.length">
        <b-input-group prepend="Server Name">
          <b-form-select name="Server Name" value-field="fullName" text-field="fullName" :options="servers" v-model="server" />
        </b-input-group>
      </b-form-group>
    </template>
  </c-modal>
</template>

<script>
import CModal from './Cmodal'
import ApprovePermission from './approvePermission'

export default {
  name: 'editServer',
  components: {ApprovePermission, CModal},
  props: {
    currentServer: {type: [String, null], default: ''},
    orderId: {type: [String, Number], default: ''},
    order: {type: Object, default: () => ({})}
  },
  data() {
    return {
      model: false,
      servers: [],
      server: '',
      progressing: false,
      approveModal: false
    }
  },
  mounted() {},
  methods: {
    showModal() {
      if (this.$showApprove([3, 4, 5, 11, 12])) {
        this.approveModal = true
      } else {
        this.getClients()
      }
    },
    openWithAcceptPermission() {
      this.approveModal = false
      this.getClients()
    },
    getClients() {
      const filter = {
        RestaurantID: this.$store.state.selectedRestaurantId,
        // UserID: localStorage.getItem('userID')
      }
      this.servers = []
      return this.$api.getRestaurant
        .GetDashboardRestaurantClient(filter)
        .then(res => {
          if (res.success) {
            res.RestaurantClients.forEach(item => {
              item.fullName = item.FirstName + ' ' + item.LastName
            })
            const available = res.RestaurantClients.filter(i => i.Role.includes('Restaurant Server'))
            this.servers = [{fullName: localStorage.getItem('name')}, ...available]
            this.model = true
            const find = available.find(i => i.fullName === this.currentServer)
            if (find) {
              this.server = find.fullName
            } else {
              this.server = this.servers[0].fullName
            }
          }
        })
        .catch(() => {})
    },
    submit() {
      this.$validator.validateAll().then(proceed => {
        if (proceed) {
          const model = {
            RestaurantID: this.$store.state.selectedRestaurantId,
            // UserID: localStorage.getItem('userID'),
            OrderID: this.orderId,
            ServerName: this.server
          }
          this.progressing = true
          return this.$api.getRestaurant
            .UpdateOrderServerName(model)
            .then(res => {
              this.progressing = false
              if (res.success) {
                this.$emit('updateOrders')
                this.hide()
              } else {
                this.$showError(res.message)
              }
            })
            .catch(() => {
              this.progressing = false
            })
        }
      })
    },
    hide() {
      this.model = false
    }
  }
}
</script>

<style scoped></style>
